import React, { Fragment, lazy, Suspense, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DataPreview, Divider, List, ListItem, Paragraph, Skeleton, useMenuOverlay, useOverlay } from '@fs/zion-ui'
import { useEvent } from '@fs/zion-frontend-friends'
import { MenuMore } from '@fs/zion-icon'
import { disabledStatuses, formatDate, treeStatusKeyMap } from '../../../helpers'
import { useGenealogyTreesContext } from '../GenealogyTreesProvider'

const GenealogyTreeMenu = lazy(() => import('../GenealogyTreeMenu'))
const DeleteOverlay = lazy(() => import('./DeleteOverlay'))

export default function GenealogyMobileTable() {
  const [t] = useTranslation()
  const { trees } = useGenealogyTreesContext()
  const menuOverlay = useMenuOverlay()
  const deleteOverlay = useOverlay()
  const [treeSelected, setTreeSelected] = useState({})

  const openMenuOverlay = useEvent((event, tree) => {
    setTreeSelected(tree)
    menuOverlay.open(event)
  })

  return (
    <DataPreview.Provider loading={!trees}>
      <DataPreview.Loading>
        <Skeleton.ListItem hasEndIcon dense />
        <Skeleton.ListItem hasEndIcon dense />
      </DataPreview.Loading>
      <DataPreview.Ready>
        <List>
          {trees?.map((tree, index) => {
            return (
              <Fragment key={tree.treeUri}>
                <ListItem
                  emphasized
                  overline={formatDate(tree.createDate)}
                  primaryText={tree.name}
                  secondaryText={
                    <>
                      {t('tree-import.people.label', { number: tree.personCount })}
                      <Paragraph size="xs">{t(treeStatusKeyMap[tree.treeStatus])}</Paragraph>
                    </>
                  }
                  endElement={
                    <ListItem.IconButton
                      disabledDescription={t('tree-import.tree-menu-disable.description', {
                        treeStatus: tree.treeStatus,
                      })}
                      disabled={disabledStatuses.includes(tree.treeStatus)}
                      key={`menuOverlay ${tree.treeUri}`}
                      data-testid={`${tree.treeUri}-options-button`}
                      Icon={MenuMore}
                      {...menuOverlay.menuButtonProps}
                      title={t('tree-import.tree.label')}
                      onClick={(event) => openMenuOverlay(event, tree)}
                    />
                  }
                />

                {index !== trees.length - 1 && <Divider />}
              </Fragment>
            )
          })}
        </List>
        <Suspense fallback="">
          {(menuOverlay.open || menuOverlay.transitioning) && (
            <GenealogyTreeMenu
              onDeleteClick={deleteOverlay.handleClick}
              menuOverlay={menuOverlay}
              tree={treeSelected}
            />
          )}

          {(deleteOverlay.isOpen || deleteOverlay.transitioning) && (
            <DeleteOverlay overlay={deleteOverlay} tree={treeSelected} />
          )}
        </Suspense>
      </DataPreview.Ready>
    </DataPreview.Provider>
  )
}
